import script from "./ConfigOptionWithChildren.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigOptionWithChildren.vue?vue&type=script&setup=true&lang=js"

import "./ConfigOptionWithChildren.vue?vue&type=style&index=0&id=50a85983&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a85983"]])

export default __exports__